export type NameGen = (state?: string) => string;

function actionName(namespace: string, verb: string, noun: string): NameGen {
	return (state: string | undefined): string => {
		return `${namespace}.${verb}.${noun}` + (typeof state === "string" ? "." + state : "");
	};
}

export default actionName;
